<template>
  <!-- MBR031 congratulation sheet — member_app_UI/song_fa_members_membership_tiers -->
  <div class="modal fade mbr-congrats" id="bottom_modal_congratulation" tabindex="-1" role="dialog"
    aria-labelledby="bottom_modal_congratulation" ref="bsmodal">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content mbr-congrats__sheet">
        <div class="modal-header mbr-congrats__head">
          <button type="button" class="mbr-congrats__close" :aria-label="$t('common.close')" data-bs-dismiss="modal">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        <div class="modal-body mbr-congrats__body">
          <p class="mbr-congrats__message" v-html="message"></p>
          <div class="mbr-congrats__art" v-if="voucherIconUrl">
            <img :src="voucherIconUrl" class="mbr-congrats__img" alt="" />
          </div>
          <h4 class="mbr-congrats__title">{{ $t('modal.earned_reward') }}</h4>
          <div class="mbr-congrats__note">
            <span class="mbr-congrats__tick" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <span>{{ $t('modal.profile_completed') }}</span>
          </div>
        </div>
      </div>
    </div>
    <button class="btn-show-modal-congratulation" style="display: none" data-bs-toggle="modal"
      data-bs-target="#bottom_modal_congratulation">Show Model</button>
  </div>
</template>

<script>
import { localStorageName, getMerchantCode } from "@/config/utils";

export default {
  name: "ExchangeStatus",
  props: {
    id: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: "",
    },
    voucherIconUrl: {
      type: String,
      default: "",
    },
    btnClose: {
      type: String,
      default: "",
    },
    btnGo: {
      type: String,
      default: "",
    },
    goPage: {
      type: Function,
      default: () => { },
    },
    memberInfo: {
      type: Object,
      required: false
    }
  },
  mounted() {
    const code = getMerchantCode();
    var merchantCode = code ? `/${code}` : ''
    this.$refs.bsmodal.addEventListener('hidden.bs.modal', event => { 
      console.log(event);
      // is not paid member ship & merchant connected to stripe && count_paid_membership_reward_by_merchant > 0
      const isCheckMerchantConnectedStripe = localStorage.getItem(localStorageName("IS_CHECK_MERCHANT_CONNECTED_STRIPE"), 'false');
      var count_paid_membership_reward_by_merchant = this.memberInfo.count_paid_membership_reward_by_merchant;
      if(!this.memberInfo.is_paid_member_ship && isCheckMerchantConnectedStripe === 'true' && count_paid_membership_reward_by_merchant > 0) {
        this.$router.push(merchantCode + '/get-member-ship');
      }
    })
  }
};
</script>
<style scoped>
/* MBR031. The old block carried the whole modal-left/right/top/bottom position kit; this modal is
   a centred dialog and never used any of it, and the block was scoped, so it is dropped. */
.mbr-congrats {
  z-index: 10000;
}

.mbr-congrats :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-congrats .modal-dialog {
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
}

.mbr-congrats__sheet {
  padding-bottom: 8px;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(215, 194, 192, 0.4);
  border-radius: var(--mbr-radius-xl);
  box-shadow: var(--mbr-shadow-modal);
  text-align: center;
}

.mbr-congrats__head {
  justify-content: flex-end;
  padding: 12px 12px 0;
  border: 0;
}

.mbr-congrats__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: var(--mbr-color-tint);
  border: 0;
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
}

.mbr-congrats__close svg {
  width: 16px;
  height: 16px;
}

.mbr-congrats__body {
  padding: 4px 24px 24px;
}

.mbr-congrats__message {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-headline-sm-size);
  font-weight: var(--mbr-headline-sm-weight);
  line-height: var(--mbr-headline-sm-line);
  letter-spacing: var(--mbr-headline-sm-tracking);
  color: var(--mbr-color-ink-headline);
}

.mbr-congrats__art {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  padding: 16px;
  background: var(--mbr-color-tint);
  border-radius: var(--mbr-radius-lg);
}

.mbr-congrats__img {
  max-width: 180px;
  max-height: 180px;
  border-radius: var(--mbr-radius-md);
  object-fit: contain;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h4 */
.mbr-congrats__title {
  margin: 20px 0 0;
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-headline-sm-size);
  font-weight: var(--mbr-headline-sm-weight);
  line-height: var(--mbr-headline-sm-line);
  color: var(--mbr-color-ink-headline);
}

.mbr-congrats__note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  font-size: var(--mbr-body-sm-size);
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-congrats__tick {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-positive);
  color: var(--mbr-color-on-primary);
}

.mbr-congrats__tick svg {
  width: 11px;
  height: 11px;
}
</style>
